import * as React from 'react';
import * as styles from './styles.css';
import { Spinner } from '@cian/ui-kit';

interface ISupplyDemandWrapperParams {
  isLoading: boolean;
  children: React.ReactElement[];
  ref?: React.Ref<HTMLDivElement>;
}

export function SupplyDemandWrapper({ children, isLoading, ref }: ISupplyDemandWrapperParams): React.JSX.Element {
  return isLoading ? (
    <div ref={ref} className={styles['wrapper']}>
      {<Spinner size={32} />}
    </div>
  ) : (
    <div ref={ref}>{children}</div>
  );
}
